export default __webpack_public_path__ + "static/media/left-black.fc3dc4e3.svg";